import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-332b9225")

_pushScopeId("data-v-332b9225")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_input = _resolveComponent("el-input")
  const _component_CUpload = _resolveComponent("CUpload")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.title,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.visible = $event)),
    width: "770px",
    "close-on-click-modal": false,
    onClose: _ctx.onCancel
  }, _createSlots({
    default: _withId(() => [
      _withDirectives(_createVNode(_component_el_form, {
        model: _ctx.formData,
        ref: "refFrom",
        rules: _ctx.rules,
        "label-width": "130px",
        inline: false
      }, {
        default: _withId(() => [
          _createVNode(_component_el_row, { gutter: 30 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "所属app:",
                    prop: "app"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.app,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.app = $event)),
                        disabled: _ctx.isView,
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.appOption, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "应用类型:",
                    prop: "osType"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.osType,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.osType = $event)),
                        disabled: _ctx.isView,
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.osTypeOption, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 30 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "app版本号:",
                    prop: "appVersion"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.appVersion,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.appVersion = $event)),
                        disabled: _ctx.isView,
                        placeholder: "如：1.0.2"
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "更新类型:",
                    prop: "upgradeMode"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.upgradeMode,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.upgradeMode = $event)),
                        disabled: _ctx.isView,
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.upgradeModeOption, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 30 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "更新描述:",
                    prop: "description"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: 3,
                        modelValue: _ctx.formData.description,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.description = $event)),
                        "show-word-limit": "",
                        maxlength: 200,
                        disabled: _ctx.isView,
                        placeholder: "请输入更新描述，可输入200字"
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.isUpload)
            ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0,
                gutter: 30
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        label: "上传安卓包文件:",
                        prop: "appFile"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.appFile,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.appFile = $event)),
                            disabled: "",
                            placeholder: "上传后的安卓文件链接"
                          }, null, 8, ["modelValue"]),
                          (!_ctx.isView)
                            ? (_openBlock(), _createBlock(_component_CUpload, {
                                key: 0,
                                action: _ctx.action,
                                headers: _ctx.headers,
                                multiple: false,
                                accept: _ctx.accept,
                                limit: _ctx.limit,
                                "file-list": _ctx.fileList,
                                maxSize: 1048576,
                                onOnSuccess: _ctx.onUploadSuccess,
                                onOnRemove: _ctx.onUploadRemove
                              }, null, 8, ["action", "headers", "accept", "limit", "file-list", "onOnSuccess", "onOnRemove"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_row, { gutter: 30 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "状态:",
                    prop: "status"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.status,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.status = $event)),
                        disabled: _ctx.isView,
                        placeholder: "请选择"
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOption, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 30 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "备注:",
                    prop: "remark"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: _ctx.formData.remark,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.remark = $event)),
                        rows: 3,
                        disabled: _ctx.isView,
                        "show-word-limit": "",
                        maxlength: 200,
                        placeholder: "请输入备注信息，可输入200字"
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 2
  }, [
    (!_ctx.isView)
      ? {
          name: "footer",
          fn: _withId(() => [
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withId(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              disabled: _ctx.loading,
              onClick: _ctx.onValidate
            }, {
              default: _withId(() => [
                _createTextVNode("确认" + _toDisplayString(_ctx.isType ==='edit'?'修改':'添加'), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        }
      : undefined
  ]), 1032, ["title", "modelValue", "onClose"]))
})